// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2wl4B","inputWrap":"CustomTip_inputWrap__3pV1Y"};